// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"SearchBar__srOnly--34ad_","hiddenInput":"SearchBar__hiddenInput--hVGeU","root":"SearchBar__root--eQsZk","input":"SearchBar__input--Q2sk9"};